import defineThemeMiddleware from '#shared/util/defineThemeMiddleware.js';
import { decode as decodeAswparam } from '#shared/util/aswparam.js';

import { getRequestCookie } from '#backend/util/request.js';

/**
 * Payment method middleware to apply the authorized payment after return
 */
export default defineThemeMiddleware(async ({ isClientProcess, isServerProcess, app, store, route, request, response, redirect }) => {
	if (isClientProcess) {
		// Generate payment source when returning from payment gateway using HPP
		const paymentSource = await app.providersLibrary.catchPaymentSource({
			type: store.state.selectedPayment?.type
		});
		// Apply payment into the cart
		await store.dispatch('applyPayment', paymentSource);
		// Clear hash from URL added by HPP library
		await app.updateUrlQuery({}, '');
		// Apply billing into the cart from payment owner
		await store.dispatch('applyBilling', store.state.payment.owner.billing);
	}
	// If next route is thank you page, we should submit the order (sofort payment for example)
	if (isServerProcess && !store.state.order?.orderState && route.name === 'thank-you') {
		try {
			const submitOrderPayload = {};
			// Load transfer tooken cookie value created by GTM/SDL
			const transferTokenCookie = 'TR_TOKEN';
			const transferTokenString = isClientProcess ? app.cookieStorage.getItem(transferTokenCookie) : getRequestCookie(request, transferTokenCookie);
			const transferTokenObject = decodeAswparam(transferTokenString || '');
			submitOrderPayload.affiliate = transferTokenObject.aff || {};
			await store.dispatch('submitOrder', submitOrderPayload);
		} catch (error) {
			// If additional information was required for the request but user cancelled, redirect to the failure url instead of error
			const errorDetail = error.app.detail?.response?.body.error?.app?.detail ?? {};
			const userActionRequired = error.app.status === 402 && (errorDetail.nextAction ?? errorDetail.pendingRedirect);
			const failureUrl = response.locals.sessionStore.store.failureUrl;
			if (userActionRequired && failureUrl) {
				redirect(301, failureUrl);
			} else {
				throw error;
			}
		}
	}
}, ({ route }) => /success/.test(route.hash) /* On client */ || route.query.paymentStatus === 'SUCCESS' /* On server */);
